import { useState } from "react";
import variants from "./variants";

const EmptyStatePanel = () => {
  const [active, setActive] = useState(variants[0]);

  return (
    <article className={"rounded-xl border overflow-hidden transition-all duration-200 " + active.container + " " + active.accent}>
      <header className="px-4 py-3 border-b border-slate-700 bg-gradient-to-r from-violet-500/20 to-fuchsia-500/20">
        <p className="text-xs uppercase tracking-widest text-slate-400">Component 10</p>
        <h3 className="text-sm md:text-base font-semibold text-slate-100">EmptyStatePanel</h3>
      </header>
      <div className="p-4 space-y-3">
        <p className="text-sm text-slate-300 leading-relaxed">Helpful empty-state panel for no data states.</p>
        <div className="inline-flex items-center justify-center px-2.5 py-1 rounded border text-xs text-violet-300 border-violet-500/40 bg-violet-500/10">Feedback</div>
        <div className="flex flex-wrap items-center gap-2 pt-1">
          {variants.map((variant) => (
            <button
              key={variant.name}
              type="button"
              onClick={() => setActive(variant)}
              className={"px-2 py-1 text-xs rounded border transition-colors " + (active.name === variant.name ? "border-slate-300 text-slate-100 bg-slate-700/70" : "border-slate-600 text-slate-300 hover:bg-slate-800")}
            >
              {variant.name}
            </button>
          ))}
        </div>
      </div>
    </article>
  );
};

export default EmptyStatePanel;


